export const timeline = [
    {
        event: 'Pre-Departure',
        time: 'August',
        description: 'First Thai Society Event. Take place at Thailand before everyone heads to UK.'
    },
    {
        event: 'First Meet',
        time: 'Early October',
        description: "First Thai Society Meeting at University of Warwick Campus. There will be a brief about Thai Society's plan."
    },
    {
        event: 'Temple Visit',
        time: 'November',
        description: 'Visit Thai Buddhist temple nearby.'
    },
    {
        event: 'Christmas Dinner',
        time: 'December',
        description: 'Eating Dinner together and play games.'
    },
    {
        event: 'Samaggi Fest',
        time: 'Jan-Feb',
        description: 'Concert performed by bands from Thailand take place at london',
        show: false
    },
    {
        event: 'Samaggi Game',
        time: 'March',
        description: 'Sport competition where we will be competing against Thai Societies from other universities',
        show: false
    },
    {
        event: 'Thai Night',
        time: 'March',
        description: 'Biggest event organised by Thai Society. Enjoy Live Music and DJs!',
        show: false
    },

]
